import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import messages from './messages';
import style from './styles.module.less';

/**
 * @typedef {import('ui-components/components/button').ButtonClickHandler} ButtonClickHandler
 */

/**
 * @param {object} props
 * @param {ButtonClickHandler} props.onClick - function to be executed when element is clicked
 * @param {boolean} props.disabled - indicates if button needs to be disabled
 * @returns {JSX.Element} The rendered EditTaxIdentifiersAddButton
 */
export const EditTaxIdentifiersAddButton = ({ onClick, disabled = false }) => (
  <span>
    <Button className={style['add-button']} disabled={disabled} onClick={onClick} theme='link'>
      <FontAwesomeIcon icon={faPlus} />
      <FormattedMessage {...messages.taxIdentifierAddButton} />
    </Button>
  </span>
);
